
    <p-accordion class = "facilitySelection" expandIcon="icon__expand" collapseIcon="icon__collapse" *ngIf="isFacilityEnabled">
        <p-accordionTab [ngClass]="" [selected]="false">
            <p-header class="p-accordion-header">
               <i class="fs6 fa fa-building"></i>
               <span class="fs6 accodionLabel">Facility</span>
            </p-header>
            <ng-container *ngIf="currentAssociatedActiveFacilities.length> 0">
                <gen-dynamic-form
                        [listenToDataChange]="true"
                        [formConfig]="formConfig"
                        [formVertical]="true"
                        [formData]="formData"
                        [updateOnBlur]="false"
                        [editMode]="true"
                        (formChange)="updateFormData($event.form)">
                </gen-dynamic-form>
                <div class = "facilityToggle">
                    <div class="Flexbox">
                        <span class="span_text_association Spacebox__lr-small Spacebox__tb-small fs7">Include cases of patients associated to selected facility</span>
                        <gen-toggle-switch
                                [active]="defaultAssociation"
                                [disabled]="false"
                                (statusUpdate)="updateSelection($event)">
                        </gen-toggle-switch>
                    </div>
                </div>
                <gen-button id="applyFacility" class="apply-button"
                            [ngClass]=""
                            (click)="updateDataToStore()"
                            [type]="'primary'"
                            [text]="'Apply'" [disabled] = "!formChanged"
                            genTooltip [tooltipPosition]="'BOTTOM'" [appendToBody]="true"
                            [iconClass]="''">
                </gen-button>
            </ng-container>
            <div *ngIf="currentAssociatedActiveFacilities.length == 0"  style ="white-space: initial;padding: 10px;">You are not authorized to view any facilities. Please contact your system administrator.</div>
        </p-accordionTab>
    </p-accordion>



